// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1910":"58b01d1c906e8466","2055":"2bc22f8c712b3c34","9727":"b8c624b1c8f74e73"}[chunkId] + ".css";
};